// action - account reducer
export const TREEVIEW = '@auth/TREEVIEW';
export const PROFILE_IMAGE = '@auth/PROFILE_IMAGE';
export const SELECTED_TREE_ITEM = '@auth/SELECTED_TREE_ITEM';
